import { useEffect } from 'react'
import { NextRouter } from 'next/router'

import { EventDetectionMethod, EventType } from '~/behavior-tracking/types'
import { logUserActivity } from '~/behavior-tracking/utility/view-event-logs.utility'

export default function usePageVisibilityTracker(router: NextRouter, userId: number | null): void {
  useEffect(() => {
    const onVisibilityChange = async (): Promise<void> => {
      if (userId == null) {
        return
      }

      const eventName = document.visibilityState === 'visible' ? EventType.PAGE_VISIBLE : EventType.PAGE_INVISIBLE

      const event = {
        eventName,
        viewKey: router.asPath,
        extra: {
          detectBy: EventDetectionMethod.DOCUMENT_VISIBILITY_CHANGE_EVENT,
        },
      }

      await logUserActivity(userId, event)
    }

    document.addEventListener('visibilitychange', onVisibilityChange)

    return () => {
      document.removeEventListener('visibilitychange', onVisibilityChange)
    }
  }, [router.asPath, userId])
}
